import type { ProductBrand } from '@@partner:types:app'

import React, { useCallback, useState } from 'react'
import { useFetchQuery } from '@@partner:graphql/query/catalog/productAvailableBrands.gql'
import { useDebounce } from 'use-debounce'

import { SelectPicker } from 'rsuite'

export interface ProductBrandsSelectorProps {
  value?: ProductBrand
  onChange?: (brand?: ProductBrand) => void
}

export default function ProductBrandsSelector ({
  value,
  onChange
}: ProductBrandsSelectorProps) {
  const [ searchName, setSearchName ] = useState('')
  const [ debouncedSearchName ] = useDebounce(searchName, 1000)

  const { data, loading, error } = useFetchQuery({ name: debouncedSearchName })

  const handleSearchNameChange = useCallback((value: string) => {
    setSearchName(value)
  }, [])

  const handleBrandsChange = useCallback(
    (...args) => {
      const [ , value ] = args
      onChange?.(value)
    },
    [ onChange ]
  )

  const handleBrandsClean = useCallback(() => {
    onChange?.()
  }, [ onChange ])

  const pickerData = data?.brands ?? (value?.id ? [ value ] : [])

  return (
    <div>
      <SelectPicker
        data={pickerData}
        value={value?.id}
        onSearch={handleSearchNameChange}
        onClean={handleBrandsClean}
        onSelect={handleBrandsChange}
        labelKey="name"
        valueKey="id"
      />
    </div>
  )
}
